<template>
  <!-- RakutenCreditModal.vue -->
  <Modal name="RakutenCreditModal" :title="title" modalClass="rakutenCreditModal" @closing="closingModal">
    <form class="rakutenCreditContainer" @submit.prevent="createToken()">
      <div class="mt-1 mb-2 fw-bold text-center" v-if="me.hasCredit">新しいクレジットカードを登録</div>
      <div class="">
        <div class="rakuten-credit-number-label">
          <label class="form-label">カード番号</label>
          <img :src="'/assets/credit-logos-nodiner.png'" />
        </div>
        <div class="rakuten-credit-input-wrapper">
          <div id="my-card-mount"></div>
          <span class="pseudo-card-mask-toggle rex-icon eye-ban-l"></span>
        </div>
      </div>

      <div class="mt-2">
        <label class="form-label">名義人</label>
        <input type="text" name="Ecom_Payment_Card_Name" class="form-control" placeholder="名義人（半角英字）" :class="rakutenCreditCardHolderName" v-model="cardHolderName" @blur="fixHolderName()" />
      </div>

      <div class="mt-2">
        <label class="form-label">有効期限 (MM/YYYY)</label>
        <div class="rakute-credit-expire-wrapper">
          <span class="rakuten-credit-month">
            <span id="my-expiration-month-mount" class="d-inline-block"></span>
          </span>
          <span class="rakuten-credit-date-divider">/</span>
          <span class="rakuten-credit-year">
            <span id="my-expiration-year-mount" class="d-inline-block"></span>
          </span>
        </div>
      </div>

      <div class="mt-2">
        <label class="form-label">セキュリティコード</label>
        <div>
          <div class="rakuten-credit-input-wrapper cvv-input">
            <div id="my-cvv-mount"></div>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <button class="btn btn-dark d-block w-100" type="submit">登録する</button>
      </div>
      <div v-if="me.hasCredit" class="text-center mt-4 registeredCreditCard">
        <hr />
        <div class="fw-bold">登録済みクレジットカード</div>
        <div class="mt-2">
          <span class="me-2 d-inline-block">**** **** **** {{ me.creditSuffix }}</span>
          <span class="d-inline-block">({{ me.creditMonth }} / {{ me.creditYear }}) <span v-if="me.creditBrandIconClass !== null" class="brandIcon ms-1"><i :class="me.creditBrandIconClass"></i></span></span>
        </div>
        <div class="mt-3">
          <a href="javascript:;" class="text-secondary text-decoration-underline" @click.prevent="deleteToken()">登録済みカード情報を削除</a>
        </div>

      </div>
    </form>
  </Modal>
</template>

<script>
import { toast } from 'vue3-toastify';

export default {
  props: [
    'me',
    'session',
    'showLoadingOverlay',
    'hideLoadingOverlay',
    'closeModal',
  ],
  data () {
    return {
      inputRendered: false,
      callback: null,
      cardHolderName: '',
      inputStyleBase: {
        'color': 'black',
        'width': 'calc(100% - 8px)',
        'font-size': '16px',
        'line-height': '24px',
        'height': '38px',
        'padding': '6px 0 6px 12px',
        'margin': '4px',
        'border': '1px solid #dee2e6',
        'background-clip': 'padding-box',
        'border': '1px solid #dee2e6',
        'border-radius': '4px',
      },
    };
  },
  computed: {
    title() {
      return 'クレジットカード情報を入力';
    },
    rakutenCreditCardHolderName() {
      const name = this.cardHolderName
      if (this.cardHolderName.length === 0) {
        return {};
      }
      if (this.checkHolderName(this.cardHolderName)) {
        return {'is-valid': true};
      }
      return {'is-invalid': true};
    },
  },
  mounted() {
  },
  beforeUnmount() {
    console.log('RakutenCreditModal beforeUnmount');
    try {
      if (payvault && payvault.destroy) payvault.destroy();
    } catch (e) {
    }
  },
  unmounted() {
  },
  methods: {
    fixHolderName() {
      this.cardHolderName = this.cardHolderName.replace(/^\s+|\s+$/g, '');
      this.cardHolderName = this.cardHolderName.toUpperCase();
    },
    checkHolderName(name) {
      return name.match(/^[A-Z\s]+$/)
    },
    show(callback = null) {
      this.callback = callback;
      this.$modal.show('RakutenCreditModal');
      this.renderInput();
    },
    async createToken() {
      const numberLength = await payvault.card.getLength('cardNumber');
      if (numberLength == 0) {
        toast('カード番号を入力して下さい。', {
          type: 'error',
          transition: 'slide',
          hideProgressBar: true,
          position: 'top-center',
          autoClose: 2000,
        });
        return;
      }
      if (this.cardHolderName.length === 0) {
        toast('名義人を入力して下さい。', {
          type: 'error',
          transition: 'slide',
          hideProgressBar: true,
          position: 'top-center',
          autoClose: 2000,
        });
        return;
      }
      if (!this.checkHolderName(this.cardHolderName)) {
        toast('名義人が正しくありません。', {
          type: 'error',
          transition: 'slide',
          hideProgressBar: true,
          position: 'top-center',
          autoClose: 2000,
        });
        return;
      }
      if (!await payvault.card.validateExpiration()) {
        toast('有効期限が正しくありません。', {
          type: 'error',
          transition: 'slide',
          hideProgressBar: true,
          position: 'top-center',
          autoClose: 2000,
        });
        return;
      }

      const cvvLength = await payvault.card.getLength('cvv');
      if (cvvLength == 0) {
        toast('セキュリティコードを入力して下さい。', {
          type: 'error',
          transition: 'slide',
          hideProgressBar: true,
          position: 'top-center',
          autoClose: 2000,
        });
        return;
      }
      if (!(await payvault.card.validateCvvForCardNumber())) {
        toast('セキュリティコードが正しくありません。', {
          type: 'error',
          transition: 'slide',
          hideProgressBar: true,
          position: 'top-center',
          autoClose: 2000,
        });
        return;
      }
      this.showLoadingOverlay();
      const token = await payvault.card.createToken({
        serviceId: process.env.RAKUTEN_SERVICEID,
        integrationCase: 'cardTokenWithCvv',
      });
      if (token.resultType !== 'success') {
        toast('このカード情報は使用できません。番号、有効期限、セキュリティーコードをご確認ください。', {
          type: 'error',
          transition: 'slide',
          hideProgressBar: true,
          position: 'top-center',
          autoClose: 5000,
        });
        this.hideLoadingOverlay();
        return;
      }
      const data = {
        ...token.maskedCardDetails,
        cardHolderName: this.cardHolderName,
        timestamp: token.timestamp,
        signature: token.signature,
      };
      this.axios({
        url: '/credit/token',
        method: 'post',
        data,
      }).then((res) => {
        if (res.data.result !== 'success') {
          toast('このカード情報は使用できません。番号、有効期限、セキュリティーコードをご確認ください。', {
            type: 'error',
            transition: 'slide',
            hideProgressBar: true,
            position: 'top-center',
            autoClose: 5000,
          });
          this.hideLoadingOverlay();
          return;
        }
        setTimeout(async () => {
          this.cardHolderName = '';
          this.$modal.hide('RakutenCreditModal');
          this.hideLoadingOverlay();
          toast('クレジットカード情報を登録しました', {
            type: 'success',
            transition: 'slide',
            hideProgressBar: true,
            position: 'top-center',
            autoClose: 2000,
          });
          await this.session(false);
          if (this.callback) {
            this.callback();
          }
        }, 500);
      }).catch((err) => {
        alert('システムエラーが発生しました');
        this.hideLoadingOverlay();
        console.log(err);
      });
    },
    renderInput() {
      // if (this.inputRendered) return;
      this.inputRendered = true;
      const inputElementStyles = this.getInputElementStyles();
      const selectStyleBase = {
        'color': 'black',
        width: '100%',
        height: '34px',
        fontSize: '16px',
        'border': '1px solid #dee2e6',
      };
      const selectElementStyles = {
        base: {...selectStyleBase,
          'border-radius': '4px'
        },
        valid: {...selectStyleBase,
          'border': '1px solid #198754',
          'border-radius': '4px'
        },
        invalid: {...selectStyleBase,
          'border': '1px solid #dc3545',
          'border-radius': '4px'
        },
        focus: {...selectStyleBase,
          'color': 'black',
          'border': '1px solid #86b7fe',
          'border-radius': '4px'
        },
      };
      try {
        if (payvault.destroy) payvault.destroy();
      } catch (e) {
      }
      payvault.setup({
        cardNumber: {
          mount: '#my-card-mount',
          styles: inputElementStyles,
          height: '46px',
          placeholder: 'カード番号',
        },
        expirationMonth: {
          mount: '#my-expiration-month-mount',
          styles: selectElementStyles,
          inputType: 'select',
        },
        expirationYear: {
          mount: '#my-expiration-year-mount',
          styles: selectElementStyles,
          inputType: 'select',
        },
        cvv: {
          mount: '#my-cvv-mount',
          styles: inputElementStyles,
          placeholder: 'CVV',
          height: '46px',
        },
      });
    },
    getInputElementStyles() {
      return {
        base: {...this.inputStyleBase,
        },
        valid: {...this.inputStyleBase,
          'border': '1px solid #198754',
          'padding-right': 'calc(1.5em + .75rem)',
          'background-repeat': 'no-repeat',
          'background-position': 'right calc(.375em + .1875rem) center',
          'background-size': 'calc(.75em + .375rem) calc(.75em + .375rem)',
        },
        invalid: {...this.inputStyleBase,
          'border': '1px solid #dc3545',
        },
        focus: {...this.inputStyleBase,
          'border': '1px solid #86b7fe',
          'box-shadow': '0 0 0 .25rem rgba(13, 110, 253, .25)',
        },
      }
    },
    deleteToken() {
      if (confirm('本当に削除しますか？')) {
        this.showLoadingOverlay();
        this.axios({
          url: '/credit/delete',
          method: 'post',
        }).then((res) => {
          setTimeout(() => {
            this.$modal.hide('RakutenCreditModal');
            this.hideLoadingOverlay();
            this.session(false);
            toast('クレジットカード情報を削除しました', {
              type: 'success',
              transition: 'slide',
              hideProgressBar: true,
              position: 'top-center',
              autoClose: 2000,
            });
          }, 500);
        }).catch((err) => {
          this.hideLoadingOverlay();
          alert('システムエラーが発生しました');
          console.log(err);
        });
      }
    },
    closingModal() {
      console.log('RakutenCreditModal closingModal');
      if (typeof this.closeModal === 'function') {
        this.closeModal();
      }
    },
  },
}
</script>
